import React from 'react';
import { AssignmentPanel } from './AssignmentPanel/AssignmentPanel';
import AssignmentReadOnlyModal from './AssignmentReadOnlyModal';
import ContextCalendar from './ContextCalendar';

/**
 * LeaderEditor - The inline editor view that appears next to the sidebar.
 */
const LeaderEditor = ({
    modalOpen,
    isReadOnly,
    editingAssignment,
    editStack,
    forwardStack,
    presetDate,
    isUndatedPreset,
    activeDateRange,
    activeResources,
    workers,
    vehicles,
    kolonnen,
    assignments,
    absences,
    assignmentsForConflicts,
    absencesForConflicts,
    categories,
    companyLoc,
    isConflictDetectionEnabled,
    panelRef,
    
    // Handlers
    onCloseEditor,
    onSaveAssignment,
    onDeleteAssignment,
    onResourcesChange,
    onDateRangeChange,
    onExportShortcut,
    onAssignmentClick,
    onAssignmentHover,
    onAssignmentHoverEnd,
    onNavigateBack,
    onNavigateForward
}) => {
    if (!modalOpen) return null;

    return (
        <div className="leader-container edit-mode">
            {isReadOnly ? (
                <AssignmentReadOnlyModal 
                    assignment={editingAssignment}
                    isOpen={modalOpen}
                    onClose={onCloseEditor}
                    onSave={onSaveAssignment}
                    onDelete={onDeleteAssignment}
                    workers={workers}
                    vehicles={vehicles}
                    assignments={assignments}
                    absences={absences}
                    assignmentsForConflicts={assignmentsForConflicts}
                    absencesForConflicts={absencesForConflicts}
                    presetDate={presetDate}
                    isUndatedPreset={isUndatedPreset}
                    companyLoc={companyLoc}
                    onResourcesChange={onResourcesChange}
                    onDateRangeChange={onDateRangeChange}
                    categories={categories}
                    kolonnen={kolonnen}
                    onDeleteVehicle={() => {}} 
                    isConflictDetectionEnabled={isConflictDetectionEnabled}
                    onOpenWorkerModal={() => {}} 
                    onOpenKolonnenManagement={() => {}}
                    onOpenConflictOverview={() => {}}
                    onConflictHover={() => {}}
                    onConflictHoverEnd={() => {}}
                    isEditMode={modalOpen}
                    onAddResource={() => {}}
                    onRemoveResource={() => {}}
                    assignedWorkers={activeResources.workers || []}
                    assignedVehicles={activeResources.vehicles || []}
                    interaction={null}
                    setInteraction={() => {}}
                />
            ) : (
                <AssignmentPanel
                    ref={panelRef}
                    onClose={onCloseEditor}
                    onSave={onSaveAssignment}
                    onDelete={onDeleteAssignment}
                    assignment={editingAssignment}
                    workers={workers}
                    vehicles={vehicles}
                    assignments={assignments}
                    absences={absences}
                    assignmentsForConflicts={assignmentsForConflicts}
                    absencesForConflicts={absencesForConflicts}
                    presetDate={presetDate}
                    isUndatedPreset={isUndatedPreset}
                    companyLoc={companyLoc}
                    onResourcesChange={onResourcesChange}
                    onDateRangeChange={onDateRangeChange}
                    categories={categories}
                    kolonnen={kolonnen}
                    isConflictDetectionEnabled={isConflictDetectionEnabled}
                    isReadOnly={isReadOnly}
                    onExport={onExportShortcut}
                />
            )}
            <ContextCalendar 
                startDate={activeDateRange.start || (editingAssignment?.start_datetime ? editingAssignment.start_datetime.split(/[T ]/)[0] : (presetDate ? presetDate.toISOString().split('T')[0] : new Date().toISOString().split('T')[0]))}
                endDate={activeDateRange.end || (editingAssignment?.end_datetime ? editingAssignment.end_datetime.split(/[T ]/)[0] : (presetDate ? presetDate.toISOString().split('T')[0] : new Date().toISOString().split('T')[0]))}
                currentStartTime={activeDateRange.startTime || (editingAssignment?.start_datetime ? editingAssignment.start_datetime.split(/[T ]/)[1]?.substring(0, 5) : '00:00') || '00:00'}
                currentEndTime={activeDateRange.endTime || (editingAssignment?.end_datetime ? editingAssignment.end_datetime.split(/[T ]/)[1]?.substring(0, 5) : '23:59') || '23:59'}
                isAllDay={activeDateRange.isAllDay !== undefined ? activeDateRange.isAllDay : (editingAssignment ? editingAssignment.all_day : false)}
                isUndated={activeDateRange.isUndated}
                currentAssignmentId={editingAssignment?.id}
                onAssignmentClick={onAssignmentClick}
                onAssignmentHover={onAssignmentHover}
                onAssignmentHoverEnd={onAssignmentHoverEnd}
                canGoBack={editStack.length > 0}
                canGoForward={forwardStack.length > 0}
                onGoBack={onNavigateBack}
                onGoForward={onNavigateForward}
            />
        </div>
    );
};

export default LeaderEditor;
